import React from "react"
import { Container, Row, Col } from "reactstrap";
import styled from "styled-components";

import Banner from "../components/Banner";
import PhotoCarousel from "../components/PhotoCarousel";

import Layout from "../components/layout";
import SEO from "../components/seo";

import Unisel1 from "../images/training/Unisel/Unisel1.jpg";
import Unisel2 from "../images/training/Unisel/Unisel2.jpg";
import Unisel3 from "../images/training/Unisel/Unisel3.jpg";
import Unisel4 from "../images/training/Unisel/Unisel4.jpg";
import Unisel5 from "../images/training/Unisel/Unisel5.jpg";
import Unisel6 from "../images/training/Unisel/Unisel6.jpg";
import Unisel7 from "../images/training/Unisel/Unisel7.jpg";

import TrainerBanner from "../images/training/training.jpg";

const Section = styled.section`
  padding: 60px 0;
`
const TnC = styled.div`
  padding: 20px 0;
  margin: 0 10px;
`
const BannerSection = styled.div`
  height: 50vh;
  position: relative;
  .bannerImage{
    background-image: url(${TrainerBanner});
    background-size: cover;
    background-position: 50% 50%;
    background-color: #0f0f0f;
    height: 100%;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5); 
    }
  }
  .bannerText{
    position: absolute;
    top: 50%;
    left: 35%;
    transform: translate(-50%, -50%);
    color: #fff;
  }
`

const trainings = [
  Unisel1,Unisel2,Unisel3,Unisel4,Unisel5,Unisel6,Unisel7,
]

const TrainingPage = () => (
  <Layout>
    <SEO title="Training&Consultation" description="Training&Consultation" />
    <BannerSection>
      <div className="bannerImage"></div>
      <div className="bannerText">
        <h3>
          Training & Consultation
        </h3>
        <p>
          3D Printing required a set of knowledge from design, data preparation and printing. <br/>
          There are so many post processing and equipment to master before can get a good finished products
        </p>
      </div>
    </BannerSection>
    <Section>
      <Container>
        <TnC>
          <h3>Training</h3>
          <Row>
            <Col xs="12" md="6">
              <p>
                Getting your hands on a 3D printer might seem like a puzzle at times. 
                Navigating the world of 3D printing requires some key knowledge: knowing how to design, prep your data, and actually do the printing. 
                With 3D Gens, we're your guides, taking you from the basics to the advanced techniques in 3D printing. Our training is flexible and tailored to your needs. 
                And we don't just stop there—after training, we're here to help with any questions or concerns you might have. 
                Our comprehensive training covers various aspects, including :
              </p>
              <ul>
                <li>Design Optimization</li>
                <li>Product Development</li>
                <li>Data preparation</li>
                <li>Handling and managing the software and machine</li>
                <li>Post-processing</li>
              </ul>
            </Col>
            <Col xs="12" md="6">
              <PhotoCarousel/>
            </Col>
          </Row>


          {/* <hr></hr>
          <Row>
            <Col xs="12" md="6">
              <ItemDiv>
                <p>
                  This is our Training Module Brochure <br/>if you are interested
                </p>
                <LinkedTraining href="https://cdn.me-qr.com/pdf/7437416.pdf" target="_blank">
                  <div className="iconTraining"/>
                  <p className="textTraining">Click Here <br/>to View</p>
                </LinkedTraining>
              </ItemDiv>
            </Col>
            <Col xs="12" md="6">
              <ItemDiv>
                <p>
                  Interested in joining our Training? <br/>Register Here
                </p>
                <LinkedRegister href="https://docs.google.com/forms/d/e/1FAIpQLSe6xW7TDRat9hZeg9Q9U8Tluf-esifl25-eW4aG4SiQckj6lA/viewform" target="_blank">
                  <div className="iconRegister"/>
                  <p className="textRegister">Click Here <br/>to Register</p>
                </LinkedRegister>
              </ItemDiv>
            </Col>
          </Row> */}
        </TnC>
      </Container>
    </Section>
  </Layout>
)

export default TrainingPage
